/**
 * This file contains custom svg icon components
 */
import GallerySvg from '../../static/database/icons/app/gallery.svg';
import HomeSvg from '../../static/database/icons/app/home.svg';
import UserSvg from '../../static/database/icons/app/user.svg';
import DiameterPipe from '../../static/database/images/icons_water_drainage/diameter-pipe.svg';
import Langd from '../../static/database/images/icons_water_drainage/length-pipe.svg';
import BorjaOm from '../../static/database/icons/product/borjaom.svg';
import Farg from '../../static/database/icons/product/material_and_color.svg';
import Gavel from '../../static/database/icons/product/gables.svg';
import Gom from '../../static/database/icons/product/gom.svg';
import Guide from '../../static/database/icons/product/guide.svg';
import OrderSummary from '../../static/database/icons/product/compilation.svg';
import Information from '../../static/database/icons/product/notes.svg';
import Matt from '../../static/database/icons/product/measure.svg';
import Tillbehor from '../../static/database/icons/product/fastenings_and_glue.svg';
import Vinkel from '../../static/database/icons/product/angles.svg';

import Fastbleck from '../../static/database/icons/product/mounting_plate.svg'
import Bakkappa from '../../static/database/icons/product/bakkappa.svg'
import Holes from '../../static/database/icons/product/holes.svg'

import Leverans from '../../static/database/icons/product/leverans.svg'
import Maskin from '../../static/database/icons/product/maskin.svg'
import Produkt from '../../static/database/icons/product/produkt.svg'

import Documents from '../../static/database/icons/app/ritningar_black.svg';
import Add from '../../static/database/icons/app/add.svg';
import OnlineplatText from '../../static/database/icons/app/onlineplat-text.svg';
import Sammanstallning from '../../static/database/icons/checkout/sammanstallning.svg';

// Profile icons region
import Logout from '../../static/database/icons/profile/log_out.svg';
import PersonalInfo from '../../static/database/icons/profile/personal_information.svg';
import BusinessInfo from '../../static/database/icons/profile/business_information.svg';
import ChangePassword from '../../static/database/icons/profile/change_password.svg';
import MyOrders from '../../static/database/icons/profile/my_orders.svg';
import EmailSetting from '../../static/database/icons/profile/email_setting.svg';
import FinanceAndAgreement from '../../static/database/icons/profile/finance_and_agreement.svg';
import Lang from '../../static/database/icons/profile/select_language.svg';
import Facebook from '../../static/database/icons/profile/fb.svg';
import Instagram from '../../static/database/icons/profile/ig.svg';
// Profile icons region end


import Foto from '../../static/database/icons/app/camera.svg'
import Search from '../../static/database/icons/app/sok.svg'

import Placeholder from '../../static/database/icons/app/placeholder.svg'
// import DemoImg from './demo_img.svg'
import Map from '../../static/database/icons/project/map.svg'
import Building from '../../static/database/icons/project/house_black_shadow.svg'
import ProjectInfo from '../../static/database/icons/project/project_information.svg'
import ContactInfo from '../../static/database/icons/project/contact_information.svg'
import Photo from '../../static/database/icons/project/photos.svg';
import Setting from '../../static/database/icons/project/settings.svg';
import Workspace from '../../static/database/icons/project/workspace.svg';
import Document from '../../static/database/icons/project/documents.svg';
import Other from '../../static/database/icons/project/others.svg';
import ProjectOrder from '../../static/database/icons/project/my_orders.svg';
import ProjectSharedIcon from '../../static/database/icons/project/shared.svg';

// menu icons
import Ownproduct from '../../static/database/icons/menu/rita.svg'
import Products from '../../static/database/icons/menu/produkter.svg';

//checkout
import Delivery from '../../static/database/icons/checkout/delivery.svg';
import Pickup from '../../static/database/icons/checkout/pick_up.svg';

//own product icons
import Grid from '../../static/database/icons/special/grid.svg';
import Revert from '../../static/database/icons/rita/back.svg';
import Forward from '../../static/database/icons/rita/forward.svg';
import DotLine from '../../static/database/icons/special/dot line.svg';
import Line from '../../static/database/icons/special/Line.svg';
import Back from '../../static/database/icons/app/back-button-1_4.svg';
import Cross from '../../static/database/icons/app/back-button-cross.svg';
import Vector from '../../static/database/icons/app/rightArrow.svg';

export const HolesIconComponent = Holes
export const BakKappaIconComponent = Bakkappa
export const FastbleckIconComponent = Fastbleck
export const GalleryIconComponent = GallerySvg;
export const HomeIconComponent = HomeSvg;

// Profile icons region
export const UserIconComponent = UserSvg;
export const LogoutComponent = Logout;
export const PersonalInfoComponent = PersonalInfo;
export const ChangePasswordComponent = ChangePassword;
export const EmailSettingComponent = EmailSetting;
export const FinanceAndAgreementComponent = FinanceAndAgreement;
export const LangIcon = Lang
export const BusinessInfoComponent = BusinessInfo;
export const MyOrdersComponent = MyOrders;
// Profile icons region end


// Project icons region
// Project icons region end

export const BorjaOmComponent = BorjaOm;
export const FargComponent = Farg;
export const GavelComponent = Gavel;
export const GomComponent = Gom;
export const GuideComponent = Guide;
export const InformationComponent = Information;
export const OrderSummaryIcon = OrderSummary;
export const MattComponent = Matt;

export const SammanstallningComponent = Sammanstallning;
export const TillbehorComponent = Tillbehor;
export const VinkelComponent = Vinkel;
export const DocumentsComponent = Documents;
export const PhotoComponent = Photo;
export const ProductsComponent = Products;
export const AddComponent = Add;
export const OnlineplatTextComponent = OnlineplatText;

export const SearchIconComponent = Search
export const OwnproductIconComponent = Ownproduct
export const FotoIconComponent = Foto
export const PlaceholderIconComponent = Placeholder
// export const DemoImgIcon = DemoImg
export const LeveransIcon = Leverans
export const MaskinIcon = Maskin
export const ProduktIcon = Produkt
export const BuildingIcon = Building
export const MapIcon = Map
export const ContactInfoIcon = ContactInfo
export const ProjectInfoIcon = ProjectInfo
export const SettingIcon = Setting
export const DeliveryIcon = Delivery
export const PickupIcon = Pickup
export const WorkspaceIcon = Workspace
export const DocumentIcon = Document
export const OtherIcon = Other
export const FBIcon = Facebook
export const IGIcon = Instagram
export const ProjectOrderIcon = ProjectOrder
export const GridIcon = Grid
export const RevertIcon = Revert
export const ForwardIcon = Forward
export const DotLineIcon = DotLine
export const LineIcon = Line
export const DiameterPipeIcon = DiameterPipe
export const LangdIcon = Langd
export const BackIcon = Back
export const CrossIcon = Cross
export const VectorIcon = Vector
export const ProjectShared = ProjectSharedIcon

import Save from '../../static/database/icons/app/save.svg';
export const SaveIconComponent = Save;